import Vue from 'vue'
import VueRouter from 'vue-router'
import Banner from '../pages/banner/bannerPage.vue';
import BannerAdd from "../pages/banner/bannerAddPage.vue";
import BannerModify from "../pages/banner/bannerModfiyPage.vue";
import Program from "../pages/program/programPage.vue";
import ProgramAdd from "../pages/program/programAddPage.vue";
import ProgramModify from "../pages/program/programModfiyPage.vue";
import ProgramUser from "../pages/program/programUserPage.vue";
import Bizcard from "../pages/bizCard/bizCardPage.vue";
import BizcardAdd from "../pages/bizCard/bizCardAddPage.vue";
import bannerModify from "../pages/bizCard/bizCardModfiyPage.vue";
import Ensentence from "../pages/enSentence/en-sentencePage.vue";
import EnsentenceAdd from "../pages/enSentence/en-sentenceAddPage.vue";
import EnsentenceModify from "../pages/enSentence/en-sentenceModfiyPage.vue";
import Curation from "../pages/curation/curationPage.vue";
import Member from "../pages/member/memberPage.vue";
import MemberView from "../pages/member/memberViewPage.vue";
import Push from "../pages/push/pushPage.vue";
import PushAdd from "../pages/push/pushAddPage.vue";
import PushView from "../pages/push/pushViewPage.vue";
import Payment from "../pages/payment/paymentPage.vue";
import Product from "../pages/product/productPage.vue";
import ProductModify from "../pages/product/productModfiyPage.vue";
import Notice from "../pages/notice/noticePage.vue";
import NoticeAdd from "../pages/notice/noticeAddPage.vue";
import NoticeModify from "../pages/notice/noticeModfiyPage.vue";
import Login from "../pages/login/login.vue";
import Unknown from "../pages/erorr/404page.vue";
import dailyWritingPage from "../pages/dw/dailyWritingPage";
import appDownloadPage from "@/pages/appDownloadPage";

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    name: 'Unknown',
    component: Unknown
  },
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/banner',
    name: 'Banner',
    component: Banner
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/banneradd',
    name: 'BannerAdd',
    component: BannerAdd
  },
  {
    path: '/bannermodify/:idx',
    name: 'BannerModify',
    component: BannerModify
  },
  {
    path: '/program',
    name: 'Program',
    component: Program
  },
  {
    path: '/programadd',
    name: 'ProgramAdd',
    component: ProgramAdd
  },
  {
    path: '/programmodify/:idx',
    name: 'ProgramModfiy',
    component: ProgramModify
  },
  {
    path: '/programuser/:idx',
    name: 'ProgramUser',
    component: ProgramUser
  },
  {
    path: '/bizcard',
    name: 'Bizcard',
    component: Bizcard
  },
  {
    path: '/bizcardadd',
    name: 'BizcardAdd',
    component: BizcardAdd
  },
  {
    path: '/bizcardmodify/:idx',
    name: 'BizcardModfiy',
    component: bannerModify
  },
  {
    path: '/ensentence',
    name: 'Ensentence',
    component: Ensentence
  },
  {
    path: '/ensentenceadd',
    name: 'EnsentenceAdd',
    component: EnsentenceAdd
  },
  {
    path: '/ensentencemodify/:idx',
    name: 'EnsentenceModfiy',
    component: EnsentenceModify
  },
  {
    path: '/curation',
    name: 'Curation',
    component: Curation
  },
  {
    path: '/member',
    name: 'Member',
    component: Member
  },
  {
    path: '/memberview/:idx',
    name: 'MemberView',
    component: MemberView
  },
  {
    path: '/push',
    name: 'Push',
    component: Push
  },
  {
    path: '/pushadd',
    name: 'PushAdd',
    component: PushAdd
  },
  {
    path: '/pushview/:idx',
    name: 'PushView',
    component: PushView
  },
  {
    path: '/payment',
    name: 'Payment',
    component: Payment
  },
  {
    path: '/product',
    name: 'Product',
    component: Product
  },
  {
    path: '/productmodify/:idx',
    name: 'ProductModify',
    component: ProductModify
  },
  {
    path: '/notice',
    name: 'Notice',
    component: Notice
  },
  {
    path: '/noticeadd',
    name: 'NoticeAdd',
    component: NoticeAdd
  },
  {
    path: '/noticemodify/:idx',
    name: 'NoticeModfiy',
    component: NoticeModify
  },
  {
    path: '/dw',
    name: 'dailyWriting',
    component: dailyWritingPage
  },
  {
    path: '/beta',
    name: 'platform',
    component: appDownloadPage
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
